import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import styled from "styled-components";
import {
	WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment$key
} from "@generated/WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment.graphql";
import { AttachmentButton, AttachmentLabel } from "./WissenwirktAttachmentHeftDisplay";
import { StripHtml } from "../../../infecto-lms-webapp/functions/helpers/StripHtml";
import { DownloadIcon } from "../nodecard/SvgNodeIcons.component";

const ATTACHMENTS_FRAGMENT = graphql`
    fragment WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment on LearnOpportunityV2 {
        structureDefinition {
            ... on LearnOpportunityRootStructureDefinition {
                extension {
                    ... on LearnOpportunityRootExtensionImpl {
                        reducedDataInTree {
                            elementTypes
                        }
                    }
                }
            }
        }
        root {
            id
            attachmentsV2 {
                title
                description
                ... on InfectopharmFileAttachment {
                    file {
                        id
                        url
                        name
                    }
                }
            }
        }
    }
`;

interface OwnProps {
	learnOpportunityFragmentRef: WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment$key;
}

export const WissenwirktAttachmentButtonsDisplay = ({learnOpportunityFragmentRef}: OwnProps) => {
	const learnOpportunity =
		useFragment<WissenwirktAttachmentButtonsDisplayFragment_LearnOpportunityV2Fragment$key>(
			ATTACHMENTS_FRAGMENT,
			learnOpportunityFragmentRef,
		);
	const elementType =
		learnOpportunity.structureDefinition.extension?.reducedDataInTree?.elementTypes;

	if (!elementType) return null;

	const hasBook = elementType.includes("file");
	const hasVideo = elementType.includes("video");
	const hasPodcast = elementType.includes("podcast");
	const attachments = learnOpportunity.root?.attachmentsV2 ?? [];
	const attachmentsArrayLength = attachments.length;

	const selectFileTitle = (title: string, index: number) => {
		const indexNumber = attachmentsArrayLength && attachmentsArrayLength > 1 ? index + 1 : "";

		if (title?.includes("FORCE")) {
			return title.split("FORCE")[1].trim().toUpperCase();
		} else {
			if (hasBook) {
				return `THEMENHEFT-PDF ${indexNumber}`;
			} else if (hasVideo) {
				return `VIDEO-TRANSKRIPT ${indexNumber}`;
			} else if (hasPodcast) {
				return `PODCAST-TRANSKRIPT ${indexNumber}`;
			} else return title.toUpperCase();
		}
	};

	return (
		<AttachmentsContainer>
			{attachments.map((attachment, index) => {
				return (
					<a
						href={attachment.file?.url!} //eslint-disable-line @typescript-eslint/no-non-null-asserted-optional-chain
						rel="noopener noreferrer"
						className="p-button-text text-primary p-0 text-sm md:text-base w-full"
						download={attachment.file?.name!} //eslint-disable-line @typescript-eslint/no-non-null-asserted-optional-chain
						target="_blank"
						key={attachment?.file?.name}
					>
						<AttachmentButton>
							<AttachmentLabel>
								{selectFileTitle(StripHtml(attachment.title || attachment.description!), index)}
							</AttachmentLabel>
							<DownloadIcon/>
						</AttachmentButton>
					</a>
				);
			})}
		</AttachmentsContainer>
	);
};

const AttachmentsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;
